import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n, EVENT_TYPES } from "@/lib/i18n";
import { SectionHeading } from "@/components/Brand";
import EventCard from "@/components/EventCard";

export default function EventsPage() {
  const { t, lang } = useI18n();
  const [events, setEvents] = useState([]);
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/events", { params: type ? { event_type: type } : {} })
      .then((r) => setEvents(r.data))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, [type]);

  return (
    <div className="mx-auto max-w-[1500px] px-4 py-14 sm:px-8 lg:px-12 lg:py-20">
      <SectionHeading label="HR Creations" title={t("events.title")} sub={t("events.sub")} />
      <div className="mt-8 flex flex-wrap gap-2" data-testid="events-type-filters">
        <button
          type="button"
          data-testid="events-filter-all"
          onClick={() => setType("")}
          className={`min-h-[44px] border px-4 text-sm transition-colors duration-300 ${
            type === "" ? "border-[#8F3329] bg-[#8F3329] text-[#FAFAF7]" : "border-[#C69A3B]/50 text-[#252525] hover:border-[#8F3329]"
          }`}
        >
          {t("common.all")}
        </button>
        {Object.keys(EVENT_TYPES).map((key) => (
          <button
            key={key}
            type="button"
            data-testid={`events-filter-${key}`}
            onClick={() => setType(key)}
            className={`min-h-[44px] border px-4 text-sm transition-colors duration-300 ${
              type === key
                ? "border-[#8F3329] bg-[#8F3329] text-[#FAFAF7]"
                : "border-[#C69A3B]/50 text-[#252525] hover:border-[#8F3329]"
            }`}
          >
            {EVENT_TYPES[key][lang]}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="mt-12 text-sm text-[#5A5752]">{t("common.loading")}</p>
      ) : (
        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-testid="events-grid">
          {events.length === 0 && <p className="text-sm text-[#5A5752]">{t("events.empty")}</p>}
          {events.map((ev) => (
            <EventCard key={ev.id} event={ev} />
          ))}
        </div>
      )}
    </div>
  );
}
